import { createSignal } from 'solid-js'

export const [playAlert, setPlayAlert] = createSignal(localStorage.play_alert === 'on')

//const beeper = new Worker('/media/beeper.js')

export function togglePlayAlert() {
  setPlayAlert(e => !e)
  localStorage.play_alert = (localStorage.play_alert === 'on') ? 'off' : 'on'
  if (playAlert()) {
    beep()
  }
}

export function beep3() {
  beeper.postMessage({})
}

export function beep() {
  (new Howl({ src: ['/media/beep.webm', '/media/beep.mp3'] })).play()
}

export function beep4() {
  (new Audio('/media/beep.mp3')).play()
  //(new Audio('/media/success.wav')).play()
}

export function beep2() {
  const frequency = 800
  const duration = 500
  //const volume  = 1

  const ctx = new (window.AudioContext || window.webkitAudioContext)()
  const oscillator = ctx.createOscillator()
  const gainNode = ctx.createGain()
  oscillator.type = 'square' // 'sine' or 'square', 'sawtooth', 'triangle'
  oscillator.frequency.setValueAtTime(frequency, ctx.currentTime) // Frequency in Hz
  //gainNode.gain.setValueAtTime(volume, ctx.currentTime) // Volume (0 to 1)

  //oscillator.connect(ctx.destination)
  oscillator.connect(gainNode)
  gainNode.connect(ctx.destination)

  oscillator.start()
  oscillator.stop(ctx.currentTime + duration / 1000)
}
